var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "plan-group-chart", class: { fullscreen: _vm.fullScreen } },
    [
      _c("BarChart", {
        staticClass: "bar-chart",
        attrs: {
          options: _vm.getOptions(),
          colors: ["#cb5d0f", "#4213ce", "#c9d906"],
        },
      }),
      _vm._v(" "),
      _vm.tableMode
        ? _c("TableView", {
            attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats" },
        [
          _c("StatCard", {
            attrs: {
              title: "Total Package",
              value: _vm.stats.totalPackage,
              unit: "site",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }